import { Navigate, Outlet, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useActiveMode } from '@/context/ActivePortalContext';
import { SupportPreviewProvider } from '@/context/SupportPreviewContext';

/**
 * Route guard for host (producer) routes.
 * Redirects non-hosts to the "Att bli värd i Farmly" page.
 * Admins with ?support_preview=1 are allowed through in read-only mode.
 */
export function HostRouteGuard() {
  const { isHost, isAdmin, isLoading } = useActiveMode();
  const [searchParams] = useSearchParams();
  const isSupportPreview = isAdmin && searchParams.get('support_preview') === '1';

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!isHost && !isSupportPreview) {
    return <Navigate to="/app/producer" replace />;
  }

  return (
    <SupportPreviewProvider>
      <Outlet />
    </SupportPreviewProvider>
  );
}
